import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, Checkbox } from 'semantic-ui-react';
import ReactTable from 'react-table';
import { PropTypes } from 'prop-types';
import classNames from 'classnames';

import * as actions from '../state/householdCategoricalTypes/actions';
import { destroyForm } from 'State/forms/actions';
import { resetDirty } from 'State/dirtyTracking/actions';
import { Main } from 'Containers';

import { HouseHoldEditModal } from './HouseHoldEditModal';
import { createToast, toastType, errorToast } from 'Common/ToastHelper';
import { DirtyWrapper } from 'Components';
import { EDIT_CASE_TYPE_FORM_NAME } from 'Common/FormEnum';
import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';

const benefitLevels = {
  2: 'Free',
  3: 'Reduced',
};

const defaultCaseType = {
  Enabled: true,
};

class HouseHoldForm extends Component {
  static propTypes = {
    mainProps: PropTypes.object.isRequired,
  };

  state = {
    caseType: defaultCaseType,
    modal: {
      open: false,
      isAdd: false,
    },
  };

  componentDidMount() {
    this.props.onRef(this);
    this.props.getHouseholdCategoricalTypes();
  }

  componentWillUnmount() {
    this.props.onRef(undefined);
  }

  componentDidUpdate(prevProps) {
    const { clearHouseholdCategoricalTypesErrorSuccess } = this.props;

    if (errorToast(this.props, prevProps, 'fetchError')) {
      clearHouseholdCategoricalTypesErrorSuccess();
    } else if (errorToast(this.props, prevProps, 'submitError')) {
      clearHouseholdCategoricalTypesErrorSuccess();
    } else if (this.props.submitted.success && !prevProps.submitted.success) {
      createToast(
        toastType.success,
        'Success',
        `Case Type successfully ${this.props.submitted.type}`,
        true
      );

      this.props.resetDirty();
      this.onCaseTypeModalClose();
      clearHouseholdCategoricalTypesErrorSuccess();
    }
  }

  showAddModal() {
    this.setState({ modal: { open: true, isAdd: true } });
  }

  onCaseTypeModalClose = () => {
    this.props.destroyForm(EDIT_CASE_TYPE_FORM_NAME);
    this.setState({
      modal: {
        open: false,
        isAdd: false,
      },
      caseType: defaultCaseType,
    });
  };

  showStatus = (original, accessor) => {
    return (
      <div style={{ textAlign: 'center' }}>
        <Checkbox checked={original[accessor] === true} disabled />
      </div>
    );
  };

  benefitLevel = (status) => {
    return <div style={{ textAlign: 'center' }}>{benefitLevels[status]}</div>;
  };

  menuOptions = [
    {
      icon: 'pencil',
      text: 'Edit',
      handler: (caseType) =>
        this.setState({ caseType, modal: { open: true, isAdd: false } }),
      disabledWhen: (caseType) =>
        this.props.isReadOnly || caseType.InUseThisYear,
    },
    {
      icon: 'trash',
      text: 'Delete',
      className: 'danger',
      handler: (caseType) =>
        this.props.deleteHouseholdCategoricalType(caseType.Id),
      disabledWhen: (caseType) =>
        this.props.isReadOnly ||
        caseType.InUseAllTime ||
        parseInt(caseType.Id, 10) < 100,
    },
  ];

  columns = [
    {
      Header: 'Enabled',
      accessor: 'Enabled',
      Cell: ({ original }) => this.showStatus(original, 'Enabled'),
    },
    {
      Header: 'Case Type',
      accessor: 'Description',
    },
    {
      Header: 'Benefit Level',
      accessor: 'Status',
      Cell: ({ original }) => this.benefitLevel(original.Status),
    },

    {
      Header: 'SNAP Equivalent',
      accessor: 'IsSNAPEquivalent',
      Cell: ({ original }) => this.showStatus(original, 'IsSNAPEquivalent'),
    },
    {
      Header: 'DC only',
      accessor: 'IsDCOnly',
      Cell: ({ original }) => this.showStatus(original, 'IsDCOnly'),
    },
    {
      resizable: false,
      width: 50,
      sortable: false,
      Cell: (gridProps) => {
        return GridContextMenu({ gridProps, options: this.menuOptions });
      },
    },
  ];

  render() {
    const {
      fetching,
      submitting,
      data,
      isReadOnly,
      mainProps,
      hide,
    } = this.props;
    const { modal } = this.state;

    return (
      <div className={classNames({ hide: hide })}>
        <Main {...mainProps}>
          <Grid columns={1}>
            <Grid.Row style={{ paddingBottom: '60px' }}>
              <ReactTable
                manual
                loading={fetching || submitting}
                data={data}
                minRows={5}
                defaultPageSize={100}
                resizable={false}
                showPagination={false}
                columns={this.columns}
              />
            </Grid.Row>
          </Grid>
          <DirtyWrapper
            closeModalYesCallback={this.onCaseTypeModalClose}
            isReadOnly={isReadOnly}
          >
            {(showDirtyConfirm) =>
              modal.open && (
                <HouseHoldEditModal
                  open={modal.open}
                  isAdd={modal.isAdd}
                  caseType={this.state.caseType}
                  onClose={showDirtyConfirm}
                />
              )
            }
          </DirtyWrapper>
        </Main>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ...state.ControlInformationState.householdCategoricalTypes,
  };
};

export default connect(mapStateToProps, {
  ...actions,
  destroyForm,
  resetDirty,
})(HouseHoldForm);



// WEBPACK FOOTER //
// ./src/pages/controlinformation/components/HouseHoldForm.js